module.exports = __webpack_public_path__ + "img/tree1.90d2480.svg";